import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
/** Uppercase section label from the Specra typography system. */ export const SpecraEyebrow = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("span", {
        className: cn('text-[length:var(--fs-ui-eyebrow)] font-medium uppercase tracking-[var(--ls-ui-eyebrow)] text-muted-foreground', className),
        ref: ref,
        ...props
    }));
SpecraEyebrow.displayName = 'SpecraEyebrow';
